module.exports = __webpack_public_path__ + "img/qilin-stage4.378175d6.png";